import { render, staticRenderFns } from "./subdomain-interstitial-container.vue?vue&type=template&id=50a53ccc"
import script from "./subdomain-interstitial-container.vue?vue&type=script&lang=js"
export * from "./subdomain-interstitial-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a53ccc')) {
      api.createRecord('50a53ccc', component.options)
    } else {
      api.reload('50a53ccc', component.options)
    }
    module.hot.accept("./subdomain-interstitial-container.vue?vue&type=template&id=50a53ccc", function () {
      api.rerender('50a53ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/subdomain-interstitial/components/subdomain-interstitial-container.vue"
export default component.exports